
<template>
  <el-dialog
    title="重命名"
    width="500px"
    :visible.sync="dialogVisible"
    @open="initData"
    @closed="clearValidate"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px" @submit.native.prevent>
      <el-form-item label="名称" prop="name">
        <el-input v-model="formData.name" placeholder="请输入名称" maxlength="34" show-word-limit  autocomplete="off" @keyup.enter.native="handleReName"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button size="mini" round @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" size="mini" round @click="handleReName">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'RenameFolder',
  props: {
    visible: { 
      type: Boolean,
      default: false
    },
    nowName: { 
      type: String,
      default: ''
    },
  },
  data() {
    return {
      formData: {
        name: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入文件名称', trigger: 'blur' },
        ],
      },
      fileExt:''
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
  },
  methods: {
    initData() {
      // this.formData.name = (this.nowName.replace(/<span[^>]*>/ig, '')).replace(/<\/span>/ig, '').trim();
      if(this.nowName.lastIndexOf(".")==-1){
         this.formData.name =this.nowName
         this.fileExt=''
      }else{
         let index = this.nowName.lastIndexOf(".")
         this.formData.name =this.nowName .substring(0,index);
         this.fileExt ="."+this.nowName .substring(index+1,this.nowName.length);
      }
    },
    handleReName() {
     var reg = /^[ ]*$/
      if(reg.test(this.formData.name)){
         this.$message.error({
          message: "文件名不能全是空格,请重新输入！！",
          offset: 200,
          customClass: "toast-classManage",
          duration: 2000,
        });
          return false
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(this.nowName === this.formData.name){
            this.dialogVisible = false;
            return false;
          }
          this.formData.name=this.formData.name+this.fileExt
          const tempData = Object.assign({}, this.formData);
          this.$emit('rename', tempData);
        } else {
          return false;
        }
      });
    },
    clearValidate() {
      this.$refs['form'].clearValidate();
    }
  }
};
</script>
<style scoped lang="less">
.dialog-footer {
  padding-top: 8px;
  text-align: center;
  .el-button--mini, .el-button--mini.is-round {
    padding: 7px 35px;
  }
}
</style>
